import Firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// 1) when seeding the database you'll have to uncomment this!
// import { seedDatabase } from '../seed';

const config = {
  apiKey: 'AIzaSyAlRQbDRKCXVd2hmeGCVz18VjCaypJUa1o',
  authDomain: 'netflix-andrew.firebaseapp.com',
  databaseURL: 'https://netflix-andrew.firebaseio.com',
  projectId: 'netflix-andrew',
  storageBucket: 'netflix-andrew.appspot.com',
  messagingSenderId: '364675244342',
  appId: '1:364675244342:web:73edf7c3bd0af76d589397',
  measurementId: 'G-66KR0K0YVL',
};

const firebase = Firebase.initializeApp(config);
// 2) when seeding the database you'll have to uncomment this!
// seedDatabase(firebase);
// 3) once you have populated the database (only run once!), re-comment this so you don't get duplicate data

export { firebase };
